import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment';
import { Form, Button, Alert, PageHeader, Divider } from "antd";
import { FormInstance } from "antd/lib/form";
import message from 'antd/lib/message'
import { AlertProps } from "antd/lib/alert";

import { sdkAndroidAttributes as formItems } from 'src/data'
import { mapFormItemToProps, randomString } from 'src/utils'
import { FormItem, FormItemContent} from 'src/components/FormItem'
import Container from 'src/components/Container'
import Services from 'src/services'
import { useRequest } from 'src/hooks';



// import AndroidNetworkTransfer from './AndroidNetworkTransfer'

const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const tailLayout = {
    wrapperCol: { offset: 6, span: 18 },
};

export function Android(props: any) {
    const { title, action } = props
    const { id } = useParams<any>()
    const isCopy = action === 'copy'
    const isEdit = !!id && !isCopy

    const [lock, setLock] = React.useState(isEdit && !isCopy)
    
    const requestUpdate = useRequest(Services.androidSdk.update)
    const requestAdd = useRequest(Services.androidSdk.add)
    const requestList= useRequest(Services.androidSdk.list)
    const requestConfig = useRequest(Services.androidSdk.getSdkConfig)
    
    const [formRef] = React.useState(React.createRef<FormInstance>());
    const history = useHistory();

    const [loading, setLoading] = React.useState<boolean>(false)
    const [alert, setAlert] = React.useState<AlertProps>()

    const toList = () => history.push('/sdk/android')

    const onFinish = (values: any) => {
        setLoading(true)
        if(id && !isCopy) {
            requestUpdate({
                    ...values,
                    sdkId: id
                })
                .then(() => {
                    message.success('保存成功')
                    toList()
                })
                .finally(() => {
                    setLoading(false)
                })
        } else {
            const params = {
                ...values,
            }

            if(isCopy) {
                params.copySdkId = id
            }
            
            requestAdd(params)
                .then((res: any) => {
                    message.success('新建成功')
                    toList()
                    // refBindNetwork.current(res.id.toString()).then(toList)
                })
                .finally(() => {
                    setLoading(false)
                })
        }
        
    };

    const onFill = (data: any) => {
        if(data === undefined) {
            data = {
                ...formItems.reduce<any>((memo, item) => {
                    memo[item.key] = randomString(16, item.key + '-')
                    return memo
                }, {})
            }
        }
        formRef.current?.setFieldsValue(data);
    }

    const formatTime = (t?:any) => moment(t).format('YYYY-MM-DD')
    const [originData, setOriginData] = React.useState<any>({})
    const [tag, setTag] = React.useState<string>('')
    const setData = (res: any[]) => {
        if(!res.length || res.length !== 1) {
            return setAlert({
                type: 'error',
                message: '出错',
                description: '返回数据错误'
            })
        }

        const data = res[0]

        if(isEdit) {
            data.manualUpdateTime = data.manualUpdateTime || formatTime(data.createTime)
        }
        if(data.versionTag === '0'){
            data.versionTag = ''
        }
        setOriginData(Object.assign({}, data))

        if(isCopy) {
            data.versionName = ''
            data.enabled = '0'
            data.versionDesc = ''
            data.tag = ''
            data.versionTag = '';
        }

        
        setTag(data.tag)

        onFill(data)
    }

    React.useEffect(() => {
        if(id) {
            setLoading(true)
            requestList({sdkId: id})
                .then(setData)
                .finally(() => {
                    setLoading(false)
                })
        } else {
            const data = {
                manualUpdateTime: formatTime()
            }
            formRef.current?.setFieldsValue(data);
        }
    }, [id])

    const [tagUrl, setTagUrl] = React.useState<string>('')
    React.useEffect(() => {
        requestConfig().then((res: any) => {
            setTagUrl(res.tagUrl)
        })
    }, [])

    let pageTitle: string = ''
    if(isCopy) {
        pageTitle = `新建${title} - 从[${originData.versionName ?? ''}]复制`
    } else if(!!id) {
        pageTitle = `编辑${title}[${originData.versionName ?? ''}]`
    } else {
        pageTitle = '新建' + title
    }

    React.useEffect(() => {
        if (!isCopy && !isEdit) {
            formRef.current?.setFieldsValue({obfuscatedConfig: '-keep public class com.tradplus.** { *; } \n-keep class com.tradplus.ads.** { *; }'})
        } else {
            // console.log('复制与编辑')
        }
    },[])
    // const refBindNetwork = React.useRef<any>();
    return (
    <div>
        <PageHeader
            onBack={toList}
            title={pageTitle}
        ></PageHeader>

        {alert && <Alert {...alert}/>}

        <Container loading={loading}>
        
            <Divider orientation="left" plain>
                基本信息
            </Divider>
            
            <Form {...layout} ref={formRef} name="control-ref" 
                onFinish={onFinish} 
                onValuesChange={(changedValues) => {
                    if(changedValues.tag) {
                        setTag(changedValues.tag)
                    }
                }}
            >
                {
                    formItems
                        .map(mapFormItemToProps)
                        .map(({
                            formItemProps,
                            formItemContentProps
                        }: any) => {
                        const {key} = formItemProps

                        if(key === 'tag' && tagUrl !== '') {
                            formItemProps.extra = <>Tag: <a href={tagUrl + tag} rel="noreferrer" target="_blank">{tagUrl + tag}</a></>
                        }

                        if(lock) {
                            formItemContentProps.disabled = true
                        }

                        return (
                            <FormItem defaultValue={originData[key]} {...formItemProps}>
                                <FormItemContent  {...formItemContentProps} />
                            </FormItem>
                        )
                    })
                }
                <Form.Item {...tailLayout}>
                    {lock ? (
                        <Button type="primary" size="large" 
                            onClick={(e) => {
                                setLock(false)
                                e.preventDefault()
                            }} 
                            htmlType="button"
                        >
                            编辑
                        </Button>
                    ) : (
                        <Button type="primary" loading={loading} size="large" htmlType="submit">
                            提交
                        </Button>
                    )}
                    
                    <Button htmlType="button" onClick={toList} size="large">
                        返回
                    </Button>
                    {/* <Button type="link" htmlType="button" onClick={onFill}>
                        Fill form
                    </Button> */}
                </Form.Item>
            </Form>
            

            {/* <Divider orientation="left" plain>
                广告网络
            </Divider> */}

            {/* <AndroidNetworkTransfer cref={refBindNetwork} isCopy={isCopy} id={id} ad_network_ids={formRef.current?.getFieldValue('ad_network_ids')} /> */}
        </Container>
    </div>
    );
}
